import { useUrlFilters } from '@/hooks/useUrlFilters';
import type { McpWithUserDataResponse, ServiceDomainResponse } from '@/openapi/schema';
import ServiceDomainFilter from '@/pages/explorer/filters/ServiceDomainFilter';
import StageFilter from '@/pages/explorer/filters/StageFilter';
import TypeFilter from '@/pages/explorer/filters/TypeFilter';
import { useCrossFilterCounts } from '@/pages/explorer/filters/useCrossFilterCounts';

import { getMcpClassification, getMcpStage, useMcpFilters } from './useMcpFilters';

export default function McpFilters({
  mcps,
  serviceDomains,
}: {
  mcps: McpWithUserDataResponse[] | undefined;
  serviceDomains: ServiceDomainResponse[] | undefined;
}) {
  const { typeOptions, typeFilter, stageFilter, stageOptions, serviceDomainFilter, serviceDomainOptions } =
    useMcpFilters(mcps, serviceDomains);

  const { updateFilterInURL } = useUrlFilters();

  const filters = {
    typeFilter,
    stageFilter,
    serviceDomainFilter,
  };

  const counts = useCrossFilterCounts(mcps ?? [], filters, [
    {
      key: 'typeFilter',
      getValue: (mcp: McpWithUserDataResponse) => getMcpClassification(mcp),
    },
    {
      key: 'stageFilter',
      getValue: (mcp: McpWithUserDataResponse) => getMcpStage(mcp),
    },
    {
      key: 'serviceDomainFilter',
      getValue: (mcp: McpWithUserDataResponse) => mcp.serviceDomain?.id,
    },
  ]);

  return (
    <div className="flex flex-col">
      <TypeFilter
        allApiCount={mcps?.length}
        classificationCount={counts['typeFilter'] ?? {}}
        classifications={typeOptions}
      />
      <StageFilter
        selectedStages={stageFilter}
        stageCounts={counts['stageFilter'] ?? {}}
        stageOptions={stageOptions}
        updateFilterInURL={updateFilterInURL}
      />
      {serviceDomainOptions.length > 0 && (
        <ServiceDomainFilter
          serviceDomainCount={counts['serviceDomainFilter'] ?? {}}
          serviceDomainOptions={serviceDomainOptions}
        />
      )}
    </div>
  );
}
